





















import {
  Vue, Component, Prop, Emit,
} from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';

@Component({
  components: {
    MainButton,
  },
})
export default class EditButton extends Vue {
  @Prop({
    required: false,
    default: false,
  })
  editModeValue!: boolean;

  @Prop() disabled!: boolean;

  @Emit('clickButton')
  clickButton(): void {}

  get editMode(): object {
    return {
      color: this.editModeValue ? 'lightGreen' : 'lightBlue',
      text: this.editModeValue ? 'Editando' : 'Editar',
      icon: !this.editModeValue,
    }
  }
}
